import { useMutation } from '@tanstack/react-query';
import {
  submitContactForm,
  type ContactFormPayload,
  type WebFormResponse,
} from '../services/webFormService';

/**
 * TanStack-Query mutation for `POST /www/contact`. Components use this
 * hook — not `submitContactForm` directly — per the project rule in
 * `CLAUDE.md`. The hook returns the standard `useMutation` shape:
 * `mutate` / `mutateAsync`, `isPending`, `isSuccess`, `error`, `reset`.
 *
 * No cache invalidation here — contact submissions are write-only from
 * the FE's perspective; there's no list view to refresh.
 */
export function useSubmitContactForm() {
  return useMutation<WebFormResponse, Error, ContactFormPayload>({
    mutationFn: (formData) => submitContactForm(formData),
  });
}
